import { NavLink } from "react-router-dom";
import { Content, Flex, FlexItem } from "@patternfly/react-core";

import { Icons } from "shared/components/Icons";

import useNavigation from "../../hooks/useNavigation";

import "./MegaMenuLink.css";

const MegaMenuLink = ({ link }) => {
  const { closeMegaMenu } = useNavigation();

  const icon = link.icon ? Icons[link.icon] : null;

  const content = (
    <Flex
      alignItems={{ default: "alignItemsFlexStart" }}
      spacer={{ default: "spacerMd" }}
      flexWrap={{ default: "nowrap" }}
    >
      {icon && (
        <FlexItem
          style={{
            width: "40px",
            minWidth: "40px",
          }}
        >
          <div className="school-mega-menu-link__icon">
            {icon}
          </div>
        </FlexItem>
      )}

      <FlexItem grow={{ default: "grow" }}>
        <Content
          component="h5"
          className="school-mega-menu-link__title"
        >
          {link.label}
        </Content>

        <Content
          component="small"
          className="school-mega-menu-link__description"
        >
          {link.description}
        </Content>
      </FlexItem>
    </Flex>
  );

  if (link.external) {
    return (
      <a
        href={link.to}
        target="_blank"
        rel="noopener noreferrer"
        className="school-mega-menu-link"
        onClick={closeMegaMenu}
      >
        {content}
      </a>
    );
  }

  return (
    <NavLink
      to={link.to}
      className="school-mega-menu-link"
      onClick={closeMegaMenu}
    >
      {content}
    </NavLink>
  );
};

export default MegaMenuLink;